import React from 'react';
import { Icon } from '../../../../../components/Icon';
import { RedactedEntry } from '../RedactedEntry';
import classNames from 'classnames';

interface PropTypes {
  redacted: boolean;
  icon: string;
  children: React.ReactNode;
  className?: string;
  label?: string;
}

export function IconEntry(props: PropTypes) {
  if (props.redacted) {
    return <RedactedEntry label={props.label} />;
  }

  return (
    <div
      className={classNames('d-flex', 'align-items-center', props.className)}
    >
      <Icon name={props.icon} className='text-dark-200 me-2 fs-4' />
      <div className='text-truncate'>{props.children}</div>
    </div>
  );
}
